import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../assets/css/style.css';
import DanLogo from '../assets/img/dan-logo.svg';
import DoneCashback from '../assets/img/DONE-Cashback-System.svg';
import MobileIcon from '../assets/img/mobile.svg';
import UserIcon from '../assets/img/user-icon.svg';

function RegisterDan() {
  const navigate = useNavigate();
  const [mobile, setMobile] = useState('');
  const [refCode, setRefCode] = useState('');
  const [error, setError] = useState('');

  const handleRegister = async () => {
    if (!mobile) {
      setError('لطفاً شماره موبایل خود را وارد کنید');
      return;
    }

    try {
      const response = await fetch('https://app.doneapp.ir/backend/register.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({ mobile, ref_code: refCode }),
      });

      const result = await response.json();
      if (result.status === 'success') {
        localStorage.setItem('mobile', mobile);
        localStorage.setItem('ref_code', refCode);
        

        navigate('/register-otp', { state: { mobile } });
      } else {
        setError(result.message);
      }
    } catch (err) {
      setError('خطا در ارتباط با سرور');
    }
  };

  return (
    <div className="login-bdy">
      <div className="logomotion tw-200">
        <div className="start-logo">
          <img src={DanLogo} alt="dan logo" />
          <img className="mt-15" src={DoneCashback} alt="cashback logo" />
        </div>
      </div>

      <div className="loginbtns-2">
        <div className="btndiv-1">
          <div className="mobileinputdiv-1">
            <img className="mobileicon-1" src={MobileIcon} alt="mobile" />
            <input
              className="mobileinput-1"
              type="number"
              placeholder="شماره موبایل خود را وارد کنید"
              value={mobile}
              onChange={(e) => setMobile(e.target.value)}
              required
            />
          </div>

          <div className="mobileinputdiv-1">
            <img className="mobileicon-1" src={UserIcon} alt="reffral code" />
            <input
              className="mobileinput-1"
              type="number"
              placeholder="در صورت داشتن معرف کد آن را وارد کنید"
              value={refCode}
              onChange={(e) => setRefCode(e.target.value)}
            />
          </div>

          {error && <p className="error-text">{error}</p>}

          <button type="submit" className="loginbtn-1" onClick={handleRegister}>
            دریافت کد ورود
          </button>
        </div>
      </div>

      <div className="loginbtns-3">
        <div className="btndiv-3">
          <button type="submit" className="loginbtn-3" onClick={() => navigate('/login')}>
            ورود به حساب کاربری
          </button>
          <button type="submit" className="forget-btn-2">
            حساب کاربری در دان دارم
          </button>
        </div>
      </div>
    </div>
  );
}

export default RegisterDan;
